/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ServiceUpdate = {
    properties: {
        serviceAddressId: {
            type: 'string',
            isNullable: true,
            format: 'uuid',
        },
        meterId: {
            type: 'string',
            isNullable: true,
            format: 'uuid',
        },
        type: {
            type: 'ServiceTypeEnum',
        },
    },
};